import React from 'react'
import clsx from 'clsx'

import SettingsSection from '../../SettingsSection'
import TimezonesMenu from '../../../../components/molecules/TimezonesMenu'
import { ENV_NAME_KEY, ENV_TZ_KEY } from '..'

import useStyles from './styles'

const EnvironmentSettings = ({
  envNameError,
  setEnvNameError,
  values,
  handleChange,
  configLoaded,
  timezonesLoaded
}) => {
  const classes = useStyles()

  return (
    <SettingsSection title='System' loaded={timezonesLoaded && configLoaded}>
      <div className={classes.envName}>
        <div>
          <span>
            <label htmlFor='env-name' className={classes.title}>
              Environment name
            </label>
            <input
              placeholder='Environment name'
              name='env-name'
              value={values.s_environment_name}
              onChange={e => {
                handleChange(ENV_NAME_KEY, e.target.value, true)
              }}
              onBlur={() => {
                if (!values.s_environment_name) {
                  setEnvNameError('Environment name must have a value')
                }
              }}
              onFocus={() => {
                setEnvNameError(null)
              }}
            />
          </span>
          {envNameError && <small>{envNameError}</small>}
        </div>
      </div>
      <div className={classes.dropdown}>
        <div className={classes.title}>Environment timezone</div>

        <TimezonesMenu
          selected={values.s_environment_timezone}
          onSelect={e => handleChange(ENV_TZ_KEY, e, true)}
          className={clsx(classes.fieldValue, classes.status)}
          disabled={!timezonesLoaded}
        />
      </div>
    </SettingsSection>
  )
}

export default EnvironmentSettings
